<div shape="pastille">
  <ion-badge shape="pastille" [ngClass]="{ filled: fill(), outlined: !fill() }" (click)="onPastilleClicked()">
    {{ todayMoment() }}
  </ion-badge>
</div>
